import { ExpandLess, ExpandMore, Search } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";

const SearchSuggestions = ({ querySelected, defaultSuggestions, isLoading = false }) => {

  const displaySuggestions = defaultSuggestions.slice(0, 12);
  const [showAllSuggestions, setShowAllSuggestions] = useState(false);
  const sectionRef = useRef(null);
  const shouldScrollToSectionRef = useRef(false);

  useEffect(() => {
    if (showAllSuggestions || !shouldScrollToSectionRef.current) {
      return;
    }

    shouldScrollToSectionRef.current = false;
    requestAnimationFrame(() => {
      sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [showAllSuggestions]);

  const visibleSuggestions = showAllSuggestions ? displaySuggestions : displaySuggestions.slice(0, 3);
  const hasMoreSuggestions = displaySuggestions.length > 3;

  const toggleSuggestions = () => {
    setShowAllSuggestions((current) => {
      const next = !current;
      if (!next) {
        shouldScrollToSectionRef.current = true;
      }
      return next;
    });
  };

  if (displaySuggestions.length === 0) {
    return isLoading ? (
      <div className='searchSuggestionsSection' role='status' aria-label='Loading topics'>
        <div className='searchSuggestionsList' aria-hidden='true'>
          {[45, 70, 55].map((width) => (
            <div className='topicSuggestionChip searchSuggestionPlaceholder' key={width}>
              <span className='searchSuggestionIcon'>
                <span className='loading searchSuggestionPlaceholderIcon' />
              </span>
              <span className='searchSuggestionPlaceholderText'>
                <span className='loading searchSuggestionPlaceholderLine' style={{ width: `${width}%` }} />
              </span>
            </div>
          ))}
        </div>
      </div>
    ) : null;
  }

  return (
    <div
      ref={sectionRef}
      className='searchSuggestionsSection'
      role='region'
      aria-label='Topics'
    >
      <div className='searchSuggestionsList'>
        {visibleSuggestions.map((suggestion, index) => (
          <button
            key={`${suggestion}-${index}`}
            type='button'
            className='topicSuggestionChip'
            aria-label={`Search for ${suggestion}`}
            onClick={() => querySelected(suggestion)}
          >
            <span className='searchSuggestionIcon'>
              <Search style={{ fontSize: '18px' }} />
            </span>
            <span className='searchSuggestionsChipLabel'>{suggestion}</span>
          </button>
        ))}
        {hasMoreSuggestions ?
          <button
            type='button'
            className='searchSuggestionsToggle'
            aria-expanded={showAllSuggestions}
            onClick={toggleSuggestions}
          >
            <span className='searchSuggestionsToggleIcon'>
              {showAllSuggestions ?
                <ExpandLess style={{ fontSize: '15px' }} />
                :
                <ExpandMore style={{ fontSize: '15px' }} />
              }
            </span>
            <span>{showAllSuggestions ? 'Less' : 'More'}</span>
          </button>
          : null}
      </div>
    </div>
  );
};

export default SearchSuggestions;
